'use client';

import { useEffect } from 'react';
import { Slider } from 'ui';

import { viewPromotion } from '@/modules/google/data-layer/data-layer';
import {
  HomePageBannerProduct,
  ProductBannerModule,
  SliderWrapperModule,
} from '@/modules/home/api';
import { mapHomePageBannerProductToGtmPromotionEventItem } from '@/shared/banners/components/homePageProduct/utils';
import { renderBanner } from '@/shared/banners/utils';

import styles from './HomePageSlider.module.scss';

export function HomePageSlider({
  data,
  products,
  bannerId,
  moduleName,
}: {
  data: SliderWrapperModule['data'];
  products: HomePageBannerProduct[];
  bannerId: number;
  moduleName: string;
}) {
  const items = (data?.banners || [])
    .filter((banner) => {
      // As of right now, only products are allowed in the slider.
      if (banner.type !== 'product-banner') {
        return false;
      }

      const data = banner.data as ProductBannerModule['data'];
      const product = products.find(
        (product) => data?.id === product.product_id
      );
      return !!product;
    })
    .map((banner, index) => {
      const data = banner.data as ProductBannerModule['data'];
      const product = products.find(
        (product) => data?.id === product.product_id
      );
      return {
        banner,
        product: product && { index, ...product },
        moduleName,
        bannerId,
      };
    });

  useEffect(() => {
    if (items.length === 0) return;
    const item = items[0];
    const bannerId = item.bannerId;
    const moduleName = item.moduleName;

    viewPromotion(
      moduleName,
      `P${bannerId}`,
      'Moduł produktowy na stronie głównej',
      items
        .filter((item) => item.product)
        .map((item, index) =>
          mapHomePageBannerProductToGtmPromotionEventItem(
            item.product!,
            index,
            moduleName,
            'Moduł produktowy na stronie głównej'
          )
        )
    );
  }, []);

  return (
    <div className={styles.HomePageSlider__wrapper}>
      <Slider
        allowSwipe
        breakpoints={{
          0: {
            slidesPerView: 2.33,
            slidesPerGroup: 2,
          },
          475: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          700: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1650: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1920: {
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        }}
        hasArrows={true}
        spaceBetween={25}
        watchOverflow={true}
        hasScrollbar
      >
        {items.map(({ banner, bannerId, moduleName, product }) => {
          return renderBanner(banner, product, moduleName, bannerId);
        })}
      </Slider>
    </div>
  );
}
